var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsDateString, IsEnum, IsOptional, IsUUID } from 'class-validator';
import { SubscriptionStatus } from '../payment/index.js';
export class ContactSubscriptionUpdateDto {
    userId;
    status;
    endingOn;
    cancelAt;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], ContactSubscriptionUpdateDto.prototype, "userId", void 0);
__decorate([
    IsEnum(SubscriptionStatus),
    Expose(),
    __metadata("design:type", String)
], ContactSubscriptionUpdateDto.prototype, "status", void 0);
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", Date)
], ContactSubscriptionUpdateDto.prototype, "endingOn", void 0);
__decorate([
    Expose(),
    IsDateString(),
    IsOptional(),
    __metadata("design:type", Object)
], ContactSubscriptionUpdateDto.prototype, "cancelAt", void 0);
//# sourceMappingURL=contact-subscription-update.dto.js.map